import { lockBodyScroll, unlockBodyScroll } from '@/utils/Common/Modal';

export default (lockBody, callback) => (data = null) => {
  if (lockBody) {
    lockBodyScroll();
  } else {
    unlockBodyScroll();
  }
  callback(data);
};
